<template>
    <!-- <sa-page-layout :showModalLoading="showModalLoading" :btnEditVisible="isThisFirmato" :btnAnnullaVisible="false"
        :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :data="jsonData"
        class="sa-no-space">
        <template slot="toolbar">
        </template>
        <template slot="toolbar-title">
            <paziente-anagrafica :linkPatient="linkPatient" :idPaziente="idPaziente"></paziente-anagrafica>
        </template>
        <template slot="table-header">
            <h3 class="sa-event-title">Dati Clinico-Strumentali Ictus</h3>
        </template>
        <template slot="table-body">
            <div class="sa-tab-scroll">
                <dati-clinico-strumentali-ictus-view-component :idEvento="id"></dati-clinico-strumentali-ictus-view-component>
            </div>
        </template>
    </sa-page-layout> -->
    <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData">
        <template slot="tab-content-event">
            <dati-clinico-strumentali-ictus-view-component :idEvento="id" @update="onUpdateJsonData"></dati-clinico-strumentali-ictus-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import UtilityMixins from "../../../../../utility/UtilityMixin";
import EventiMixins from "../../../utility/mixins/EventiMixins";
import DatiClinicoStrumentaliIctusViewComponent from "./DatiClinicoStrumentaliIctusViewComponent.vue";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";

export default {
    mixins: [UtilityMixins, EventiMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { DatiClinicoStrumentaliIctusViewComponent, EventiViewComponent },
    data() {
        return {
            titoloEvento: "Dati Clinico-Strumentali Ictus",
            linkback: null,
            pathResource: "/cardiodaticlinicistrumentaliictus",
            pathResourceFirma: "/cardiodaticlinicistrumentaliictus",
            jsonData: {},
            id: null,
            linkPrintData: null,
            showModalLoading: false,
            fontScale: 2,
            linkedit: null,
            pathRestValidation: "/validation",
            isThisFirmato: false,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixins.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.jsonData.idPaziente = this.$route.query.idPaziente;
        me.id = this.$route.params.id;
    },
    methods: {
        onFirmaUpdate() {
            let me = this;
            me.loadData();
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
    },
};
</script>
